import BackButton from "../BackButton";
import Logo from "../Logo";
import HaederComposition from "./HeaderComposition";

function Index() {
  const param = document.location.pathname;
  return (
    <HaederComposition>
      {param === "/" ? (
        <div
          style={{
            display: "flex",
            width: "60%",
            alignItems: "center",
          }}
        >
          <Logo />
        </div>
      ) : (
        <div style={{ display: "flex" }}>
          <Logo />
          <BackButton />
        </div>
      )}
    </HaederComposition>
  );
}

export default Index;
